'use client';

import type { auth } from '@repo/auth/wholesale';
import { baseUrl } from '@repo/utils';
import { customSessionClient, phoneNumberClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const createClient = () =>
  createAuthClient({
    baseURL: baseUrl(),
    fetchOptions: {
      credentials: 'include',
      headers: {
        'X-App-Context': 'wholesale',
      },
    },
    plugins: [customSessionClient<typeof auth>(), phoneNumberClient()],
  });

type AuthClient = ReturnType<typeof createClient>;

declare global {
  // eslint-disable-next-line no-var
  var __wholesale_auth_client: AuthClient | undefined;
}

let client = globalThis.__wholesale_auth_client;
if (!client) {
  client = createClient();
  globalThis.__wholesale_auth_client = client;
}
const authClient: AuthClient = client;

export const { signIn, signUp, signOut, useSession, phoneNumber, requestPasswordReset, resetPassword } = authClient;
